import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  styled,
  Typography
} from '@mui/material';
import * as _ from "lodash";
import OtpInput from "../../components/OtpInput"
import theme from "../../constants/theme"
import { AppDispatch, RootState } from "../../state/store"
import { resetErrors } from "../../state/auth/authSlice"
// import ErrorMsg from "../ErrorMsg";
import { SIGNUP_PROCESS_STEPS } from "../../constants";
import { maskedEmailUtil } from "../../utils";
import { CancelDeleteUserButton as ContinueBtn } from "../Button";


// const StyledButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(2),
//   borderRadius: '60px',
//   color: '#081B22',
//   background: 'linear-gradient(97.57deg, #89E141 -27.78%, #29E6CE 112.55%)',
// }));

const Note = styled(Typography)(() => ({
  fontWeight: 'bold',
  marginTop: '5px'
}))

interface SmsVerificationProps {
  handleOtpVerify: (params: any) => void;
  handleOtpResend: () => void;
  mobileNo: string;
  email: string;
  showRememberDevice?: boolean;
  rememberDevice?: boolean;
  onRememberDeviceChange?: (remember: boolean) => void;
}

const SmsVerification = ({
  handleOtpVerify,
  handleOtpResend,
  mobileNo,
  email,
  showRememberDevice = false,
  rememberDevice = false,
  onRememberDeviceChange
}: SmsVerificationProps) => {
  const { error, newUserPayload: { isEmailOptVerified }, otpToken } = useSelector((state: RootState) => state.auth);
  const [otp, setOtp] = useState('');
  const [timer, setTimer] = useState(null);
  const [disableResendBtn, setDisableResendBtn] = useState(true);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const id = setTimeout(() => {
      if (timer === 0) {
        setTimer(null)
        setDisableResendBtn(false)
      }
      else if (timer !== null) {
        setTimer(prev => prev - 1)
      }
    }, 1000)
    return () => clearTimeout(id)
  }, [timer]);

  useEffect(() => {
    setTimer(30);
    setDisableResendBtn(true)
    setOtp("");
    return () => {
      dispatch(resetErrors())
    }
  }, [isEmailOptVerified]);

  const lastDigits = ((num) => {
    const digits = num.length;
    return num.slice(mobileNo.length - 4, digits)
  })(mobileNo)

  const handleRemoveError = () => {
    dispatch(resetErrors())
  }
  const icon = isEmailOptVerified ? "/assets/images/messageNotif.png" : "/assets/images/email.png"

  const maskedEmail = maskedEmailUtil(email);

  const verifyOtpParams = { stepType: isEmailOptVerified ? SIGNUP_PROCESS_STEPS.VERIFY_MOBILE_OTP : SIGNUP_PROCESS_STEPS.VERIFY_EMAIL_OTP, otp, otpToken }
  return <>
    <Container>
      <Typography variant={"h4"} textAlign={"center"} mb={2}>{isEmailOptVerified ? "Verify Your Phone Number" : "Verify Your Email"}</Typography>
      <Box display={"flex"} justifyContent="center" alignItems="center" flexDirection={"column"}>
        <Box
          display="flex"
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Box
            display={"flex"}
            width={100}
            height={100}
            borderRadius={60}
            alignItems={'center'}
            justifyContent={'center'}
            bgcolor={theme.colors.lightGreenBg}
          >
            <Box width={40} display="flex" justifyContent={"center"} >
              <img src={icon} alt="Your Alt Text" style={{ width: '100%' }} />
            </Box>
          </Box>
        </Box>
        <Box textAlign="center">
          <p>Please enter the verification code sent to {isEmailOptVerified ? `XXXXXX${lastDigits}` : `${maskedEmail}`} to continue.</p>
          <h3>Verification Code:</h3>
        </Box>
        <Box textAlign="center" sx={{ width: "100%" }}>
          <OtpInput handleResendCode={handleOtpResend} numberOfDigits={6} otp={otp} setOtp={setOtp} disableResendBtn={disableResendBtn} handleRemoveError={handleRemoveError} error={error} setTimer={setTimer} setDisableResendBtn={setDisableResendBtn} />
          <Note>(Note: The code expires in 10 minutes.)</Note>
          {/* {error ? <ErrorMsg error={error} /> : null} */}
          <Typography variant="h4" sx={{ mt: 2 }}>{timer}</Typography>
          {showRememberDevice && (
            <Box mt={2} display="flex" justifyContent="center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberDevice}
                    onChange={(e) =>
                      onRememberDeviceChange?.(e.target.checked)
                    }
                    color="primary"
                  />
                }
                label="Remember this device"
              />
            </Box>
          )}
        </Box>
      </Box>
      <Box display="flex" justifyContent={"center"}>
        <ContinueBtn
          variant="contained"
          fullWidth
          onClick={() => {
            handleOtpVerify(verifyOtpParams)
          }}
          disabled={otp.length !== 6}
          sx={{
            marginTop: 2,
            background: theme.gradient.primary,
            color: theme.colors.primaryText
          }}
        >
          Continue
        </ContinueBtn>
      </Box>
    </Container>
  </>
}


export default SmsVerification;
